import React from "react";

const PrivacyPolicy: React.FC = () => {
  return (
    <div
      style={{
        maxWidth: "800px",
        margin: "0 auto",
        padding: "40px 20px",
        lineHeight: "1.6",
      }}
    >
      <h1 style={{ color: "#333", marginBottom: "2rem" }}>Privacy Policy</h1>

      <p>Last updated: {new Date().toLocaleDateString()}</p>

      <h2>Information We Collect</h2>
      <p>
        We collect information you provide directly to us, such as when you
        create an account, subscribe to our newsletter, or contact us for
        support.
      </p>

      <h2>How We Use Your Information</h2>
      <p>
        We use the information we collect to provide, maintain, and improve our
        services, communicate with you, and ensure the security of our platform.
      </p>

      <h2>Information Sharing</h2>
      <p>
        We do not sell, trade, or otherwise transfer your personal information
        to third parties without your consent, except as described in this
        policy.
      </p>

      <h2>Data Security</h2>
      <p>
        We implement appropriate security measures to protect your personal
        information against unauthorized access, alteration, disclosure, or
        destruction.
      </p>

      <h2>Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, please contact us
        at privacy@example.com.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
